// Module
var code = `<div class="row">
	<div class="col-md-12">
		<table class="table">
			<tr>
				<th>Partition</th>
				<th ng-repeat="host in hosts">
					{{host}}
				</th>
				<th>Total</th>
				<th>Actions</th>
			</tr>
			<tr ng-repeat="(key, info) in partitions | toArray | orderBy:key:true" >
				<td>{{info.\$key}}</td>
				<td ng-repeat="host in hosts">
					{{info.parts[host].rows | number}} <br/>
					{{info.parts[host].bytes | filesize:1}}
				</td>
				<td>{{info.size | filesize:1 }}</td>
				<td>
					<button ng-if="info.\$key != 'All'" class="btn btn-danger btn-xs" ng-click="drop_partition(info.\$key)">DROP</button>
				</td>
			</tr>

		</table>
	</div>
</div>`;
// Exports
module.exports = code;